import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["img"]

    connect() {
        if (!this.imgTarget) return;

        const img = this.imgTarget;
        const parent = this.element;

        const done = () => parent.classList.add("pi-loaded");

        if (img.complete) {
            done();
        } else {
            img.addEventListener("load", done, { once: true });
            img.addEventListener("error", done, { once: true });
        }
    }
}